<template>
  <div
    ref="consoleOutput"
    data-testid="console-output"
    class="bg-gp-midnight-1 shadow-3xl h-[28rem] overflow-auto rounded-md p-4"
    @vue:updated="handleAutoScroll"
    @vue:mounted="handleAutoScroll"
  >
    <console-line-stdout v-for="(message, index) in props.messages" :key="index" :message="message" />
  </div>
</template>

<script setup lang="ts">
import { AnsiUp } from "ansi_up/ansi_up";
import { provide, ref, watch } from "vue";
import type { ConsoleMessage } from "../../../graphql";
import ConsoleLineStdout from "./ConsoleLineStdout.vue";

// Provide a single AnsiUp instance to all ConsoleLineStdout children so that
// ANSI color state is preserved across consecutive lines in the same console session.
provide("ansiUp", new AnsiUp());

const props = defineProps<{
  messages: Array<ConsoleMessage>;
  autoScrollButton: boolean;
}>();
const consoleOutput = ref<HTMLDivElement>();

function scrollToBottom(behavior?: ScrollBehavior) {
  if (consoleOutput.value) {
    consoleOutput.value?.scrollTo({
      top: consoleOutput.value.scrollHeight - consoleOutput.value.clientHeight,
      behavior,
    });
  }
}

function handleAutoScroll() {
  if (props.autoScrollButton) {
    scrollToBottom();
  }
}

watch(
  () => props.autoScrollButton,
  (newState) => {
    if (newState) {
      scrollToBottom("smooth");
    }
  },
);
</script>
